import { Locale, locales } from '@ae/shared';
import { UserLoginChangeParams } from '@ae/shared-comp';

declare global {
  interface Window {
    AEComponentProps: StandaloneComponentProps;
  }
}

type OnLocaleChange = (locale: string) => void | undefined;
type OnUserLoginChange = (userData: UserLoginChangeParams) => void | undefined;

export type StandaloneComponentProps = {
  supportedLngs: Locale[];
  onLocaleChange?: OnLocaleChange;
  onUserLoginChange: OnUserLoginChange;
  assetsPath?: string;
  basePath?: string;
  apiDomain?: string;
  apiEndpoint?: string;
  keycloakId?: string;
  header: {
    showMr1?: boolean;
    hideBackground?: boolean;
    showTopBar?: boolean;
  };
  footer: {
    hideHelpCenter: false;
  };
};

export const defaultStandaloneComponentProps = {
  assetsPath: '',
  basePath: '',
  apiDomain: undefined,
  apiEndpoint: undefined,
  supportedLngs: locales,
  keycloakId: undefined,
  onLocaleChange: undefined,
  header: {
    showMr1: false,
    hideBackground: false,
    showTopBar: false,
  },
  footer: {
    hideHelpCenter: false,
  },
};

export const standaloneComponentProps = {
  ...defaultStandaloneComponentProps,
  ...window.AEComponentProps,
};
